module.exports = __webpack_public_path__ + "3a1b413ab56d9067af93c3a49682fa10.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/star.svg
// module id = 120
// module chunks = 0